import { Position } from 'react-flow-renderer';

export interface ProcedureData {
  name: string;
}

export interface Procedure extends ProcedureData {
  id: string;
  createdAt: string;
  updatedAt: string;
  yaml: {
    steps: (TaskStep | FormStep)[];
  };
}

export interface ProcedureName {
  name: string;
}

export interface NameValidation {
  checkProcedureName: (data: ProcedureName) => Promise<boolean>;
}

export interface SubTasksForm {
  name: string;
  steps: (TaskStep | FormStep)[];
}

export interface Step {
  name: string;
  seconds?: number;
}

export interface TaskStep extends Step {
  type: StepTypes.task;
  description: string;
  nextStep: string;
  conditions?: Condition[];
}

export interface FormStep extends Step {
  type: StepTypes.form;
  conditions: Condition[];
  // formType: keyof typeof FormTypes;
}

export interface Condition {
  name: string;
  type: keyof typeof conditionTypes;
  values: ValueRow[];
  isSelected: boolean;
}

export interface ValueRow {
  operator:
  | keyof typeof stringOperators
  | keyof typeof numericOperators
  | keyof typeof booleanOperators;
  value: string;
  nextStep: string;
}

export const stringOperators = {
  // CONTAINS: 'CONTAINS',
  // NOTCONTAINS: 'NOTCONTAINS',
  EQUAL: 'EQUAL',
  NOTEQUAL: 'NOTEQUAL',
  // STARTWITH: 'STARTWITH',
  // ENDWITH: 'ENDWITH',
};

export const numericOperators = {
  EQUAL: 'EQUAL',
  NOTEQUAL: 'NOTEQUAL',
  GREATERTHAN: 'GREATERTHAN',
  LESSTHAN: 'LESSTHAN',
  GREATERTHANOREQUAL: 'GREATERTHANOREQUAL',
  LESSTHANOREQUAL: 'LESSTHANOREQUAL',
};

export const conditionTypes = {
  STRING: 'STRING',
  NUMERIC: 'NUMERIC',
  BOOLEAN: 'BOOLEAN',
  ARRAY: 'ARRAY',
  IMAGE: 'IMAGE',
};

export const booleanOperators = {
  EQUAL: 'EQUAL',
  NOTEQUAL: 'NOTEQUAL',
};

interface TextBoxType {
  id: FormTypes.textbox;
  data: {
    key: string;
    operation: string;
  };
}

interface MultipleType {
  id: FormTypes.multiple;
  data: {
    name: string;
  }[];
}

interface BooleanType {
  id: FormTypes.boolean;
  data: {
    name: string;
  }[];
}

export enum StepTypes {
  task = 'TASK',
  form = 'FORM',
}

export enum FormTypes {
  multiple = 'MULTIPLE',
  textbox = 'TEXTBOX',
  boolean = 'BOOLEAN',
}

// export interface BootstrapKeyUpdateForm {
//   name: string;
//   thingsProfileId: string;
//   labels: string[];
//   isAuto: boolean;
// }
export interface Chip {
  id: string;
  name: string;
}

export interface Component extends Chip {
  type?: string;
  position: {
    x: number;
    y: number;
  };
  errorMsg?: string;
  destinations?: Destination[];
}

export interface LinkRelation {
  sourceId: string;
  targetId: string;
  inPort: Position;
  outPort: Position;
  type: string;
}

export interface Destination {
  alarmStatusId: string;
  alarmStatusName: string;
}
